module.exports = __webpack_public_path__ + "static/media/telecommunications_icon.34f80ca0.svg";